<template lang="pug">
  el-row#question-builder
    
    // Main Form
    el-form#form-builder(
      :model="question"
      :rules="rules"
      ref="question"
      label-position="top")

      // Question Title
      el-row(:gutter="80")
        el-col(:span="12")    
          el-form-item(prop="title")    
            label(:class="$style.label") Question Title
            el-input(
              placeholder="Enter Quiz Title"
              minlength="1"
              :maxlength="uiSettings.TITLE"
              v-model="question.title") 
        // Score
        el-col(:span="5" style="float: right;")            
          el-form-item(prop="score")
            label(:class="$style.label") Score
            el-input(
              placeholder="Enter the score"
              v-model="question.score")   

      // Question Text
      el-form-item(prop="text")
        label(:class="$style.label") Question Text
        rich-editor(
          minlength="1"
          :maxlength="uiSettings.CONTENT"
          v-model="question.text")     

      el-row.margin-top-30(:gutter="30")
        el-col(:span="12")
          el-form-item(prop="correct_answers")
            // Correct Answer
            label(:class="$style.label") Correct Answers:
            rich-editor.margin-top-10(
              minlength="1"
              :maxlength="uiSettings.CONTENT"
              v-model="correctTmp")    
      
          el-button.margin-top-10.margin-bottom-15(
            type="primary"
            size="small"
            icon="el-icon-circle-plus-outline"
            @click="addCorrectAnswer"
          ) Add to Correct Answers

          div.margin-top-5(
            v-for="(answer, index) in correctAnswers"
            :key="answer"
          )
            el-row
              el-col(:span="21")
                p(class="correctOption" v-html="answer")
              el-col(:span="2" align="right")
                el-button(type="info" plain @click="removeCorrectAnswer(index)")
                  i(class="el-icon-close")

        el-col(:span="12")
          el-form-item(prop="other_answers")
            // Other Answers
            label(:class="$style.label") Incorrect Options:
            rich-editor.margin-top-10(
              minlength="1"
              :maxlength="uiSettings.CONTENT"
              v-model="otherTmp")    
 
          el-button.margin-top-10.margin-bottom-15(
            type="primary"
            size="small"
            icon="el-icon-circle-plus-outline"
            @click="addOtherAnswer"
          ) Add to Incorrect Options

          div.margin-top-5(
            v-for="(answer, index) in otherAnswers"
            :key="answer"
          )
            el-row
              el-col(:span="21")
                p(class="correctOption incorrectOption" v-html="answer")
              el-col(:span="2" align="right")
                el-button(type="info" plain @click="removeOtherAnswer(index)")
                  i(class="el-icon-close")

      el-row(:gutter="80")
        el-col(:span="12")
          // Tags
          el-form-item.margin-top-30(
            v-if="$store.state.adminData.userId !== null"
            prop="tags")
            label(:class="$style.label") Tags
            br
            el-select(
              v-model="searchParams"
              multiple
              filterable
              reserve-keyword
              placeholder=""
              no-data-text="No tags found"
              no-match-text="No tag matches found"
              style="width: 100%;")
              el-option#tag-options(
                v-for="item in tagsList"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              )
        
      // Buttons
      el-row.margin-top-30(:gutter="20")
        el-col#buttons(:span="24" style="margin-bottom: 2%;")
          el-button-group(style="float: right;")
            el-button(
              class="normal-button"
              icon="el-icon-error"
              @click="onCancelClicked") Cancel
            el-button(
              class="primary-button"
              icon="el-icon-document"
              @click="onSubmitValidate('question')") Save                     
            
</template>

<script>
  import RichEditor from '@/components/utils/RichEditor'
  import utilMixin from '@/components/mixins/utilMixin'
  import {MAX_LENGTH} from '@/defines/constants'

  export default {
    name: 'SelectForm',

    components: {
      RichEditor,
    },  

    mixins: [utilMixin],

    props: {
      question: {
        type: Object,
        required: true,
        default: () => {},
      },            

      action: {
        type: String,
        required: true,
      },

      tagsList: {
        type: Array,
        default: () => { return [] },
      },
    },

    data() {
      return {
        select: ['correct', 'others'],

        excludeData: ['createdAt', 'updatedAt'],
        searchParams: [],
        correctTmp: '',
        otherTmp: '',

        correctAnswers: [],
        otherAnswers: [],

        uiSettings: MAX_LENGTH,
        rules: {
          title: [
            { required: true, message: 'Please input the Question\'s title', trigger: 'blur' },
            { min: 1, max: MAX_LENGTH.TITLE,
              message: 'Length should be 0 to ' + MAX_LENGTH.TITLE, trigger: 'blur' },
          ],
          text: [
            { required: true, message: 'Please input the Question text', trigger: 'blur' },
            { min: 1, max: MAX_LENGTH.CONTENT,
              message: 'Length should be 0 to ' + MAX_LENGTH.CONTENT, trigger: 'blur' },
          ],
          correct_answers: [
            { validator: this.validateCorrectAnswers, trigger: 'blur' },
          ],
          other_answers: [
            { validator: this.validateOtherAnswers, trigger: 'blur' },
          ],
        },        
      }
    },

    mounted() {
      this.populateForm()
    },

    methods: {
      onSubmitValidate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.question.quiz_id = this.$store.state.quizData.id
            this.question.resource_id = this.$store.state.quizData.resourceId
  
            // Add tags
            if (this.searchParams.length > 0) {
              this.question.tags = []
              this.searchParams.forEach((item, index) => {
                this.question.tags.push(item)
              })
            }

            // Add Correct answers
            this.question.correct = []
            for (let i=0; i < this.correctAnswers.length; i += 1) {
              this.question.correct.push(this.correctAnswers[i].trim())
            }
           
            // Add Incorrect answers
            this.question.others = []
            for (let i=0; i < this.otherAnswers.length; i += 1) {
              this.question.others.push(this.otherAnswers[i].trim())
            }

            // Validation Bypass
            this.question.correct_answer = 0

            // Create new question
            this.question.isNew = (this.action === 'create') ? true : false
            this.$emit('onProcessing', true)
            this.axios.post('/api/quiz/' + this.question.quiz_id + '/question', this.question)
              .then((result) => {
                this.$emit('onProcessing', false)
                this.mNotification({message: result.data.message})
                this.question.id =  result.data.object.id
                this.$emit('onQuestionSaved')
              })
              .catch((error) => {
                this.mNotification({error: error, message: 'Your Question was not saved.'})
              })            
          } else {
            return false
          }
        })
      },

      onCancelClicked() {
        this.$refs.question.resetFields()
        this.custom_symbols = []
        this.$emit('formCancelClicked')
      },

      addCorrectAnswer() {
        if (this.correctTmp.length === 0) {
          return
        }

        this.correctAnswers.push(this.correctTmp)
        this.$set(this, 'correctTmp', '')
      },

      addOtherAnswer() {
        if (this.otherTmp.length === 0) {
          return
        }

        this.otherAnswers.push(this.otherTmp)
        this.$set(this, 'otherTmp', '')
      },

      removeCorrectAnswer(index) {
        this.correctAnswers.splice(index, 1)
      },

      removeOtherAnswer(index) {
        this.otherAnswers.splice(index, 1)
      },

 
      validateCorrectAnswers (rule, value, callback) {
        let errors = ''
        if (this.correctAnswers.length < 1) {
          errors += 'Please input at least one correct answer.'
        }

        if (errors !== '') {
          callback(new Error(errors))
        } else {
          callback()
        }
      },

      validateOtherAnswers (rule, value, callback) {
        let errors = ''
        if (this.otherAnswers.length < 1) {
          errors += 'Please input at least one extra incorrect option.'
        }

        if (errors !== '') {
          callback(new Error(errors))
        } else {
          callback()
        }
      },

      populateForm() {
        if (this.question.correct.length > 0) {
          this.question.correct.forEach(item => this.correctAnswers.push(item))
        }
        if (this.question.others.length > 0) {
          this.question.others.forEach(item => this.otherAnswers.push(item))
        }

        if (this.question.tags !== undefined && this.question.tags !== null) {
          this.question.tags.forEach((item, index) => {
            this.searchParams.push(item)
          })
        }
      },
    },
  }
</script>

<style module>  

  .correctOption {
    color: #17C964;
    margin: 0 0 0;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding: 0.75em;
  }

  .incorrectOption {
    color: #F2135D;
  }

</style>
